import React, {
  useState,
  useEffect,
  createContext,
  useContext,
  useMemo,
  useRef,
} from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { vasthuUrl } from "../component/Api";

const ConsultantContext = createContext();

export const ConsultantProvider = ({ children }) => {
  const alertRef = useRef(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const userId = window.sessionStorage.getItem("userId");
  const token = window.sessionStorage.getItem("token");
  const lang = window.localStorage.getItem("i18nextLng");

  const setAlertFunction = (fn) => {
    alertRef.current = fn;
  };

  const chatAlertCall = () => {
    const id = window.sessionStorage.getItem("consultantId");
    vasthuUrl
      .post(
        "/vasthu/user/calltoconsultant",
        { to: id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        console.log("txnres", res.data);
        console.log("Call ringing...");
      })
      .catch((e) => {
        console.log("Error in chatAlertCall:", e);
      });
  };

  const handleWalletCall = () => {
    const consultant = window.sessionStorage.getItem("consultantId");
    const user = window.sessionStorage.getItem("userId");
    try {
      vasthuUrl
        .post(`/vasthu/user/callFromUserToConsultant`, {
          from: consultant,
          to: user,
        })
        .then((res) => {
          console.log("callllllllllllll", res);
          if (res.status == 200) {
            if (alertRef.current) {
              alertRef.current(t("USR.CAL.PROCED.BTN"), "success");
            }
            setTimeout(() => {
              navigate("/audiocallstatus", {
                state: { callStatus: "USR.CAL.PROCED.BTN" },
              });
            }, 3000);
          } else {
            if (alertRef.current) {
              alertRef.current(t("USR.CAL.FAILD.BTN"), "error");
            }
            setTimeout(() => {
              navigate("/audiocallstatus", {
                state: { callStatus: "USR.CAL.FAILD.BTN" },
              });
            }, 3000);
          }
        });
    } catch (e) {
      console.log("err", e);
    }
  };

  const handleFreeCall = () => {
    const consultant = window.sessionStorage.getItem("consultantId");
    const user = window.sessionStorage.getItem("userId");
    try {
      vasthuUrl
        .post(`/vasthu/user/callFromUserToConsultantfree`, {
          from: consultant,
          to: user,
        })
        .then((res) => {
          if (res.status == 200) {
            if (alertRef.current) {
              alertRef.current(t("USR.CAL.PROCED.BTN"), "success");
            }
            setTimeout(() => {
              navigate("/audiocallstatus", {
                state: { callStatus: "USR.CAL.PROCED.BTN" },
              });
            }, 3000);
          } else {
            if (alertRef.current) {
              alertRef.current(t("USR.CAL.FAILD.BTN"), "error");
            }
            setTimeout(() => {
              navigate("/audiocallstatus", {
                state: { callStatus: "USR.CAL.FAILD.BTN" },
              });
            }, 3000);
          }
        });
    } catch (e) {
      console.log("err", e);
    }
  };

  const handleChat = () => {
    const userId = window.sessionStorage.getItem("userId");
    const consultantId = window.sessionStorage.getItem("consultantId");
    try {
      vasthuUrl
        .post(`/initiateChat`, {
          from: userId,
          to: consultantId,
          lng: lang,
        })
        .then((res) => {
          console.log("chat after", res.status);
          navigate("/chatscreen");
        });
    } catch (e) {
      console.log("err", e);
    }
  };

  const handleFreeChat = () => {
    const userId = window.sessionStorage.getItem("userId");
    const consultantId = window.sessionStorage.getItem("consultantId");
    try {
      vasthuUrl
        .post(`/initiateChat/makeFreeChat`, {
          from: userId,
          to: consultantId,
          lng: lang,
        })
        .then((res) => {
          console.log("chat after", res.status);
          navigate("/chatscreen");
          window.sessionStorage.removeItem("pendingAction");
        });
    } catch (e) {
      console.log("err", e);
    }
  };

  const memoedValue = useMemo(
    () => ({
      setAlertFunction,
      chatAlertCall,
      handleWalletCall,
      handleFreeCall,
      handleChat,
      handleFreeChat,
    }),
    []
  );

  return (
    <ConsultantContext.Provider value={memoedValue}>
      {children}
    </ConsultantContext.Provider>
  );
};

export const UseConsultant = () => {
  return useContext(ConsultantContext);
};
